<template>
  <i :title=text v-b-tooltip.hover.top class="info_bullet">i</i>
</template>

<script>
export default {
  props: ["text"],
  filters: {},
  methods: {},
  computed: {},
};
</script>